/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { GenericTableData } from './generic-table-data.service';


@Injectable({
  providedIn: 'root'
})
export class FittingSizeDataService extends GenericTableData {

  resetTableSubject: Subject<boolean> = new Subject<boolean>();

}
